/**
 * 导航翻译 - 英文
 * Navigation Translations - English
 */
import { NavTranslations } from './zh';
import { brand } from '@/lib/brand';

export const navEn: NavTranslations = {
  // Application name
  appName: brand.shortName,
  appFullName: 'Full-Featured OA System',
  
  // Main navigation
  dashboard: 'Dashboard',
  overview: 'Overview',
  organization: 'Organization',
  approvals: 'Approvals',
  automation: 'Automation',
  parts: 'Parts Inventory',
  formEngine: 'Form Management',
  audit: 'Audit Logs',
  logs: 'System Logs',
  notifications: 'Notifications',
  users: 'User Management',
  
  // App group titles
  businessApps: 'Business Apps',
  systemApps: 'System Apps',
  developerTools: 'Developer Tools',
  adminTools: 'Admin Tools',
  
  // Others
  home: 'Home',
  settings: 'Settings',
  profile: 'Profile',
  logout: 'Logout',
  help: 'Help Center',
  feedback: 'Feedback',
  tickets: 'Tickets',
  aiAssistant: 'AI Assistant',
  knowledgeBase: 'Knowledge Base',
  performance: 'Performance',
  devtracker: 'DevTracker',
  meetingAttendance: 'Meeting Attendance',
  siteAttendance: 'Site Attendance',
  syncCenter: 'Sync Center',
  robotManager: 'Robot Manager',
  platformMaster: 'Master Data',
  opsCenter: 'Ops Center',
  aiUsage: 'AI Coding Usage',
  iamAdmin: 'Security Governance',
  internalApps: 'My Apps',

  // Sidebar
  sidebar: {
    expandMenu: 'Expand Menu',
    collapseMenu: 'Collapse Menu',
    brandName: brand.brandName,
    officeAutomation: 'Smart Office Space',
  },
  
  // Feedback submenu
  feedbackMenu: {
    myFeedback: 'My Feedback',
    feedbackManagement: 'Feedback Management',
  },
};
